export const MaritalStatuses = Object.freeze({
  MARRIED: { key: 'M', value: 'Married' },
  UNMARRIED: { key: 'U', value: 'Unmarried' },
});

export const getMaritalStatuses = () => Object.values(MaritalStatuses).map((status) => ({
  id: status.key,
  text: status.value,
  obj: status,
}));
